














































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import sceneFragment from "../fragments/scene";
import studioFragment from "../fragments/studio";
import { sceneModule } from "../store/scene";
import actorFragment from "../fragments/actor";
import imageFragment from "../fragments/image";
import movieFragment from "../fragments/movie";
import MovieCard from "../components/MovieCard.vue";
import moment from "moment";
import LabelSelector from "../components/LabelSelector.vue";
import Lightbox from "../components/Lightbox.vue";
import ImageCard from "../components/ImageCard.vue";
import InfiniteLoading from "vue-infinite-loading";
import { Cropper } from "vue-advanced-cropper";
import ImageUploader from "../components/ImageUploader.vue";
import { actorModule } from "../store/actor";
import IActor from "../types/actor";
import IImage from "../types/image";
import IMovie from "../types/movie";
import ILabel from "../types/label";
import { contextModule } from "../store/context";
import { watch, unwatch } from "../util/scene";
import MarkerItem from "../components/MarkerItem.vue";
import hotkeys from "hotkeys-js";
import CustomFieldSelector from "../components/CustomFieldSelector.vue";
import ActorGrid from "../components/ActorGrid.vue";
import VideoPlayer from "../components/VideoPlayer.vue";

interface ICropCoordinates {
  left: number;
  top: number;
  width: number;
  height: number;
}

interface ICropResult {
  coordinates: ICropCoordinates;
}

@Component({
  components: {
    MovieCard,
    ActorGrid,
    LabelSelector,
    Lightbox,
    ImageCard,
    InfiniteLoading,
    Cropper,
    ImageUploader,
    MarkerItem,
    CustomFieldSelector,
    VideoPlayer,
  },
  beforeRouteLeave(_to, _from, next) {
    sceneModule.setCurrent(null);
    next();
  },
})
export default class SceneDetails extends Vue {
  $refs!: {
    player: VideoPlayer;
  };

  actors = [] as IActor[];
  images = [] as IImage[];
  movies = [] as IMovie[];
  lightboxIndex = null as number | null;

  labelSelectorDialog = false;
  allLabels = [] as ILabel[];
  selectedLabels = [] as number[];
  labelEditLoader = false;

  screenshotLoader = false;

  infiniteId = 0;
  page = 0;

  thumbnailDialog = false;
  thumbnailLoader = false;
  thumbnailDisplay = null as string | null;
  selectedThumbnail = null as File | null;
  crop: ICropCoordinates = { left: 0, top: 0, width: 0, height: 0 };

  uploadDialog = false;
  isUploading = false;

  markers = [] as { _id: string; name: string; time: number }[];
  markerName = "" as string | null;
  markerRating = null as number | null;
  markerFavorite = false;
  markerBookmark = false;
  markerDialog = false;
  markerLabelSelectorDialog = false;
  selectedMarkerLabels = [] as number[];
  markerLabelSearchQuery = "";

  autoPaused = false;
  manuallyStarted = false;

  labelSearchQuery = "";

  editCustomFields = {} as any;
  hasUpdatedFields = false;

  pluginLoader = false;

  processed = false;

  runPlugins() {
    if (!this.currentScene) return;

    this.pluginLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!) {
          runScenePlugins(id: $id) {
            processed
            preview {
              _id
            }
            ...SceneFragment
            actors {
              ...ActorFragment
              thumbnail {
                _id
                color
              }
            }
            studio {
              ...StudioFragment
            }
            movies {
              ...MovieFragment
              scenes {
                ...SceneFragment
              }
              actors {
                ...ActorFragment
              }
            }
            markers {
              _id
              name
              time
              labels {
                _id
                name
              }
              thumbnail {
                _id
              }
            }
          }
        }
        ${sceneFragment}
        ${actorFragment}
        ${studioFragment}
        ${movieFragment}
      `,
      variables: {
        id: this.currentScene._id,
      },
    })
      .then((res) => {
        sceneModule.setCurrent(res.data.runScenePlugins);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.pluginLoader = false;
      });
  }

  updateCustomFields() {
    if (!this.currentScene) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            customFields
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          customFields: this.editCustomFields,
        },
      },
    })
      .then((res) => {
        sceneModule.setCustomFields(res.data.updateScenes[0].customFields);
        this.hasUpdatedFields = false;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  createScreenshot() {
    this.screenshotLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation($id: String!, $sec: Float!) {
          screenshotScene(id: $id, sec: $sec) {
            _id
          }
        }
      `,
      variables: {
        // @ts-ignore
        id: this.currentScene._id,
        sec: this.$refs.player.currentProgress(),
      },
    })
      .then((res) => {
        sceneModule.setThumbnail(res.data.screenshotScene._id);
      })
      .finally(() => {
        this.screenshotLoader = false;
      });
  }

  removeMarker(id: string) {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeMarkers(ids: $ids)
        }
      `,
      variables: {
        ids: [id],
      },
    }).then((res) => {
      this.markers = this.markers.filter((m) => m._id != id);
    });
  }

  createMarker() {
    if (!this.currentScene) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $scene: String!
          $name: String!
          $time: Int!
          $rating: Int
          $favorite: Boolean
          $bookmark: Long
          $labels: [String!]
        ) {
          createMarker(
            scene: $scene
            name: $name
            time: $time
            rating: $rating
            favorite: $favorite
            bookmark: $bookmark
            labels: $labels
          ) {
            _id
            name
            time
            rating
            favorite
            bookmark
            labels {
              _id
              name
            }
          }
        }
      `,
      variables: {
        scene: this.currentScene._id,
        name: this.markerName,
        time: Math.floor(this.$refs.player.currentProgress()),
        rating: this.markerRating,
        favorite: this.markerFavorite,
        bookmark: this.markerBookmark ? Date.now() : null,
        labels: this.selectedMarkerLabels.map((i) => this.allLabels[i]).map((l) => l._id),
      },
    }).then((res) => {
      this.markers.unshift(res.data.createMarker);

      this.markers.sort((a, b) => a.time - b.time);
      this.markerName = "";
      this.markerDialog = false;
    });
  }

  formatTime(secs: number) {
    return moment().startOf("day").seconds(secs).format("H:mm:ss");
  }

  currentTimeFormatted() {
    if (this.$refs.player) return this.formatTime(this.$refs.player.currentProgress());
  }

  openMarkerDialog() {
    if (!this.allLabels.length) this.loadLabels();
    this.$refs.player.pause();
    this.markerDialog = true;
  }

  async unwatchScene() {
    if (this.currentScene) await unwatch(this.currentScene);
  }

  async watchScene() {
    if (this.currentScene) await watch(this.currentScene);
  }

  get aspectRatio() {
    return contextModule.sceneAspectRatio;
  }

  get videoPath() {
    if (this.currentScene)
      return `${serverBase}/media/scene/${this.currentScene._id}?password=${localStorage.getItem(
        "password"
      )}`;
  }

  @Watch("currentScene.actors", { deep: true })
  onActorChange(newVal: any[]) {
    this.actors = newVal;
  }

  openUploadDialog() {
    this.uploadDialog = true;
  }

  changeCrop(crop: ICropResult) {
    this.crop = {
      left: Math.round(crop.coordinates.left),
      top: Math.round(crop.coordinates.top),
      width: Math.round(crop.coordinates.width),
      height: Math.round(crop.coordinates.height),
    };
  }

  readImage(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) resolve(reader.result.toString());
        else reject("File error");
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async readThumbnail(file: File) {
    if (file) this.thumbnailDisplay = await this.readImage(file);
  }

  uploadThumbnail() {
    if (!this.currentScene) return;

    this.thumbnailLoader = true;

    ApolloClient.mutate({
      mutation: gql`
        mutation(
          $file: Upload!
          $name: String
          $crop: Crop
          $actors: [String!]
          $labels: [String!]
          $scene: String
          $compress: Boolean
        ) {
          uploadImage(
            file: $file
            name: $name
            crop: $crop
            actors: $actors
            labels: $labels
            scene: $scene
            compress: $compress
          ) {
            ...ImageFragment
            actors {
              ...ActorFragment
            }
            scene {
              _id
              name
            }
          }
        }
        ${imageFragment}
        ${actorFragment}
      `,
      variables: {
        file: this.selectedThumbnail,
        name: this.currentScene.name + " (thumbnail)",
        scene: this.currentScene._id,
        crop: {
          left: this.crop.left,
          top: this.crop.top,
          width: this.crop.width,
          height: this.crop.height,
        },
        actors: this.currentScene.actors.map((a) => a._id),
        labels: this.currentScene.labels.map((a) => a._id),
        compress: true,
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsThumbnail(image._id);
        this.thumbnailDialog = false;
        this.thumbnailDisplay = null;
        this.selectedThumbnail = null;
      })
      .finally(() => {
        this.thumbnailLoader = false;
      });
  }

  openThumbnailDialog() {
    this.thumbnailDialog = true;
  }

  removeImage(index: number) {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeImages(ids: $ids)
        }
      `,
      variables: {
        ids: [this.images[index]._id],
      },
    })
      .then((res) => {
        this.images.splice(index, 1);
        this.lightboxIndex = null;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  updateImage({ index, key, value }: { index: number; key: string; value: any }) {
    const images = this.images[index];
    images[key] = value;
    Vue.set(this.images, index, images);
  }

  get currentScene() {
    return sceneModule.current;
  }

  async fetchPage() {
    if (!this.currentScene) return;

    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: ImageSearchQuery!) {
            getImages(query: $query) {
              items {
                ...ImageFragment
                labels {
                  _id
                  name
                }
                actors {
                  ...ActorFragment
                  avatar {
                    _id
                    color
                  }
                }
                scene {
                  _id
                  name
                }
              }
            }
          }
          ${imageFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            sortDir: "asc",
            sortBy: "addedOn",
            page: this.page,
            scenes: [this.currentScene._id],
          },
        },
      });

      return result.data.getImages.items;
    } catch (err) {
      throw err;
    }
  }

  infiniteHandler($state) {
    this.fetchPage().then((items) => {
      if (items.length) {
        this.page++;
        this.images.push(...items);
        $state.loaded();
      } else {
        $state.complete();
      }
    });
  }

  setAsThumbnail(id: string) {
    if (!this.currentScene) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            thumbnail {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          thumbnail: id,
        },
      },
    })
      .then((res) => {
        sceneModule.setThumbnail(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updateSceneLabels(labels: ILabel[]) {
    if (!this.currentScene) return Promise.reject();

    return ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            labels {
              _id
              name
              aliases
            }
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          labels: labels.map((l) => l._id),
        },
      },
    })
      .then((res) => {
        sceneModule.setLabels(res.data.updateScenes[0].labels);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  editLabels() {
    if (!this.currentScene) return;

    this.labelEditLoader = true;
    return this.updateSceneLabels(this.selectedLabels.map((i) => this.allLabels[i]))
      .then((res) => {
        this.labelSelectorDialog = false;
      })
      .finally(() => {
        this.labelEditLoader = false;
      });
  }

  async loadLabels() {
    const res = await ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
        }
      `,
    });

    this.allLabels = res.data.getLabels;
  }

  openLabelSelector() {
    if (!this.currentScene) return;

    if (!this.allLabels.length) {
      this.loadLabels()
        .then((res) => {
          if (!this.currentScene) return;
          this.selectedLabels = this.currentScene.labels.map((l) =>
            this.allLabels.findIndex((k) => k._id == l._id)
          );
          this.labelSelectorDialog = true;
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      this.labelSelectorDialog = true;
    }
  }

  get videoDuration() {
    if (this.currentScene) return this.formatTime(this.currentScene.meta.duration);
    return "";
  }

  imageLink(image: any) {
    return `${serverBase}/media/image/${image._id}?password=${localStorage.getItem("password")}`;
  }

  rate($event) {
    if (!this.currentScene) return;

    const rating = $event;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: SceneUpdateOpts!) {
          updateScenes(ids: $ids, opts: $opts) {
            rating
          }
        }
      `,
      variables: {
        ids: [this.currentScene._id],
        opts: {
          rating,
        },
      },
    }).then((res) => {
      sceneModule.setRating(rating);
    });
  }

  get thumbnail() {
    if (this.currentScene && this.currentScene.thumbnail)
      return `${serverBase}/media/image/${
        this.currentScene.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return `${serverBase}/broken`;
  }

  get studioLogo() {
    if (this.currentScene && this.currentScene.studio && this.currentScene.studio.thumbnail)
      return `${serverBase}/media/image/${
        this.currentScene.studio.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return "";
  }

  onLoad() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getSceneById(id: $id) {
            processed
            preview {
              _id
            }
            ...SceneFragment
            actors {
              ...ActorFragment
              thumbnail {
                _id
                color
              }
            }
            studio {
              ...StudioFragment
            }
            movies {
              ...MovieFragment
              scenes {
                ...SceneFragment
              }
              actors {
                ...ActorFragment
              }
            }
            studio {
              _id
              name
              thumbnail {
                _id
              }
            }
            markers {
              _id
              name
              time
              labels {
                _id
                name
              }
              thumbnail {
                _id
              }
            }
          }
        }
        ${sceneFragment}
        ${actorFragment}
        ${studioFragment}
        ${movieFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      if (!res.data.getSceneById) return this.$router.replace("/scenes");

      sceneModule.setCurrent(res.data.getSceneById);

      this.processed = res.data.getSceneById.processed;
      this.actors = res.data.getSceneById.actors;
      this.movies = res.data.getSceneById.movies;
      this.markers = res.data.getSceneById.markers;
      this.markers.sort((a, b) => a.time - b.time);
      this.editCustomFields = res.data.getSceneById.customFields;

      // TODO: wait for player to mount, get event...?
      setTimeout(() => {
        if (this.$route.query.t) {
          const time = parseInt(<string>this.$route.query.t);
          this.$refs.player.seek(time, <string>this.$route.query.mk_name);
          this.$refs.player.play();
        }
      }, 500);
    });
  }

  beforeMount() {
    this.onLoad();
  }

  goToPreviousMarker() {
    const progress = this.$refs.player.currentProgress();
    const prevMarkers = this.markers.filter((m) => m.time < progress - 5);
    if (prevMarkers.length) {
      const prevMarker = prevMarkers.pop() as {
        _id: string;
        name: string;
        time: number;
      };
      this.$refs.player.seek(prevMarker.time, prevMarker.name);
    } else this.$refs.player.seek(0);
  }

  goToNextMarker() {
    const progress = this.$refs.player.currentProgress();
    const nextMarker = this.markers.find((m) => m.time > progress);
    if (nextMarker) this.$refs.player.seek(nextMarker.time, nextMarker.name);
  }

  destroyed() {
    hotkeys.unbind("b");
    hotkeys.unbind("n");
    hotkeys.unbind("*");
  }

  mounted() {
    const hasModifier = (ev: KeyboardEvent) => ev.ctrlKey || ev.altKey || ev.shiftKey || ev.metaKey;

    hotkeys("n", () => {
      this.goToNextMarker();
      return false;
    });

    hotkeys("b", () => {
      this.goToPreviousMarker();
      return false;
    });

    hotkeys("*", (ev) => {
      if (ev.keyCode == 37 && !hasModifier(ev)) {
        // left
        this.$refs.player.seekRel(-5);
      } else if (ev.keyCode == 39 && !hasModifier(ev)) {
        // right
        this.$refs.player.seekRel(5);
      } else if (ev.keyCode == 70 && !hasModifier(ev)) {
        // f
        this.$refs.player.toggleFullscreen();
      } else if (ev.keyCode == 75 && !hasModifier(ev)) {
        // k
        this.$refs.player.togglePlay(true);
      } else if (ev.keyCode == 77 && !hasModifier(ev)) {
        // m
        this.$refs.player.toggleMute(true);
      } else if (ev.keyCode == 145) {
        // scroll lock
        this.$refs.player.panic();
      }
    });

    window.onblur = () => {
      if (
        this.$refs.player &&
        !this.$refs.player.isPaused() &&
        !document.hasFocus() &&
        contextModule.scenePauseOnUnfocus
      ) {
        this.$refs.player.pause();
        this.autoPaused = true;
        this.$refs.player.notice("Auto pause", 4000);
      }
    };

    window.onfocus = () => {
      if (
        document.hasFocus() &&
        this.$refs.player &&
        contextModule.scenePauseOnUnfocus &&
        this.autoPaused &&
        this.manuallyStarted
      ) {
        this.$refs.player.play();
        this.$refs.player.notice("", 0);
        this.autoPaused = false;
      }
    };

    document.addEventListener(
      "visibilitychange",
      () => {
        if (this.$refs.player && contextModule.scenePauseOnUnfocus) {
          const isPaused = this.$refs.player.isPaused();

          if (document.hidden) {
            if (!isPaused) {
              this.$refs.player.pause();
              this.autoPaused = true;
              this.$refs.player.notice("Auto pause", 4000);
            }
          } else if (this.autoPaused && this.manuallyStarted) {
            this.$refs.player.play();
            this.autoPaused = false;
            this.$refs.player.notice("");
          }
        }
      },
      false
    );
  }
}
